// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 2 hooks for backend/shared.

import { useBackend } from '../useBackend'

/** POST /api/shared/getCapabilities */
export function useGetCapabilities<T = any>() {
  return useBackend<T>('shared/getCapabilities')
}

/** POST /api/shared/getDocumentsSyncedAt */
export function useGetDocumentsSyncedAt<T = any>() {
  return useBackend<T>('shared/getDocumentsSyncedAt')
}
